import * as _ from 'lodash';
import * as $ from 'jquery';
import * as d3 from 'd3';

import { FormatHelper } from './helpers/format';

//this function will return the wrapped text in array
// function wordwrap( str, width, brk, cut ) {
//   brk = brk || 'n';
//   width = width || 75;
//   cut = cut || false;
//   if (!str) { return str; }
//   var regex = '.{1,' +width+ '}(\s|$)' + (cut ? '|.{' +width+ '}|.+$' : '|\S+?(\s|$)');
//   console.log(str.match( RegExp(regex, 'g') ).join( brk ));
//   var str_arr = str.match( RegExp(regex, 'g') ).map(function(obj){
//     //return obj.trim();
//     return obj;
//   })
//   return str_arr;
// }

function wrap_word_with_char_count(orig_str, width){
  var arr = orig_str.split(" ");
  for(var i = 0; i < arr.length; i++){
    if(arr[i] == "") arr.splice(i, 1);
  }

  // return [];
  var wrap_str_arr = [];
  // var count;
  var width = width;
  // var arr_length = arr.length;
  // var first_time = true, allow_concat = true;;
  var iteration_count = 0;

  _.each(arr, function(t){
    if (iteration_count > 0) {
      if (t.lenth + wrap_str_arr[iteration_count - 1].length <= width) {
        wrap_str_arr[iteration_count - 1] =  wrap_str_arr[iteration_count - 1] + ' ' + t;
      } else {
        wrap_str_arr.push(t);
      }

    } else {
      wrap_str_arr.push(t);
    }

    iteration_count++;
  });

  return wrap_str_arr;
}

export function getSortedData(settings) {
  const dataArr = Object.entries(settings.data);
  return _.fromPairs(_.orderBy(dataArr, d => {
    if (settings.sortField === 'value') return d[1];
    return d[0];
  }, settings.sortType));
}

export function getEventDatum(datum) {
  return {
    key: datum.data[0],
    value: datum.data[1],
  }
}

export function PieDonut(options) {
  var settings = $.extend({ // Merge options to default settings.
    $el: d3.select("body"),
    data: {},
    color: d3.scaleOrdinal(d3.schemeCategory10),
    unitName: "",
    format: d3.format(',.0f'),
    chartType: "donut",
    showPercentage: "",
    width: 960,
    height: 500,
    margin: {top: 10, right: 0, bottom: 20, left: 100},
    showLegendLine: false,
    showTitle: true,
    showUnit: true,
    showTotal: true,
    multiChart: false,
    isLock: false,
    enableMouseInteraction: true,
    sortField: 'key',
    sortType: 'desc',
    onClick: null,
    onHover: null,
  }, options);

  var self = this;
  Object.keys(settings).forEach(function(k) {
    self[k] = settings[k];
  });

  this.render();
}
PieDonut.prototype.render = function() {
  var self = this;

  var sortedData = this.data; // getSortedData(self);
  var chartType = self.chartType;
  var showUnit = self.showUnit;
  var showPercentage = self.showPercentage;
  var multiChart = self.multiChart;
  var width = self.width;
  if (width < 350) {
    width = 350;
  }
  var height = self.height;
  var $el = self.$el;
  var color = self.color;
  var showLegendLine = self.showLegendLine;
  var showTitle = self.showTitle;
  var showTotal = self.showTotal;
  var enableMouseInteraction = self.enableMouseInteraction;
  var numberFormat = d3.format(",d");
  var svgWidth  = width - self.margin.left - self.margin.right,
      svgHeight = height - self.margin.top - self.margin.bottom;
  var radius = Math.min(self.width, self.height) / 2;
  var donutText = "donut";
  var radisuMultiply = 1.2;
  var innerRadiusDivisor, outerRadiusDivisor;

  if (self.width <= 400) {
    outerRadiusDivisor = 2;
    innerRadiusDivisor = 1.4;
  } else if (self.width <= 700) {
    outerRadiusDivisor = 3;
    innerRadiusDivisor = 1.4;
  }
  // else if(self.width <= 700) {
  //   outerRadiusDivisor = 4;
  //   innerRadiusDivisor = 1.4;
  // }
  else{
    outerRadiusDivisor = 5;
    innerRadiusDivisor = 1.8;
  }

  const pie = d3.pie()
    .sort(null)
    // .sort((a, b) => {
    //   const d3SortFnc = this.sortType === 'asc'
    //     ? d3.ascending : d3.descending;
    //   if (this.sortField === 'value') {
    //     return d3SortFnc(a[1], b[1]);
    //   }
    //   return d3SortFnc(a[0], b[0]);
    // })
    .value(function(d) {
      return d[1];
    });
  const pieData = pie(Object.entries(sortedData));

  if (showLegendLine) {
    radius = Math.min((width*4/5), (height*4/5)) / 2.5;
  } else {
    radius = Math.min(width, height) / 2.5;
  }

  // @NOTE: not sure whether to check for svg exist or not
  // BEGIN
  var trans_x,
      trans_y,
      outerRadius = radius - (radius / outerRadiusDivisor),
      innerRadius,
      totalTextY,
      totalUnitTextY,
      totalUnitTextFontSize,
      lineY1,
      lineY2;

  // set radius depend on chart type
  if (chartType === donutText) {
      innerRadius = radius - (radius / innerRadiusDivisor);
      totalTextY = 0;//radius / 18;
      totalUnitTextY = (radius / 18) * 2;

      if(width < 400) totalUnitTextFontSize = 0.5;
      else totalUnitTextFontSize =  0.7;

      lineY1 = -(radius / 3);
      lineY2 = -(radius / 5.8)
  } else {
      innerRadius = 0;
      if(showLegendLine){
          totalTextY = radius*1.4;
          totalUnitTextY = (radius  + (radius / 10))*1.4;
      } else {
          totalTextY = radius;
          totalUnitTextY = (radius  + (radius / 10));
      }
      totalUnitTextFontSize = 1;
      lineY1 = -(radius / 1.8);
      lineY2 = -(radius / 2.5)
  }

  // set chart horizental and vertical alignment
  if (multiChart){
  	trans_x = width / 2.5;
    $el.select('center').style('width', trans_x * 2 + 'px');
  } else {
    trans_x = width / 2;
  }
  trans_y = height / 2;

  // set arc
  const arc = d3.arc() // d3.svg.arc()
	  .outerRadius(outerRadius)
	  .innerRadius(innerRadius);
  if (showLegendLine) {
    var outerArc = d3.arc() // d3.svg.arc()
      .innerRadius(outerRadius * radisuMultiply)
      .outerRadius(outerRadius * radisuMultiply);
  }

	// set chart height to cover unit area (if needed)
  this.$el.select('svg').remove();
	// if (showUnit) {
  // 	svg = $el.append("svg")
	//    	.attr("class", chartType + "-svg")
	//     .attr("width", width)
	//     .attr("height", height)
  //   .append("g")
	//     .attr("transform", "translate(" + trans_x + "," + trans_y + ")");
  // } else{
  //   svg = $el.append("svg")
	//     .attr("class", chartType + "-svg")
	//     .attr("width", svgWidth)
	//     .attr("height", svgHeight)
	//     .append("g")
	//     .attr("transform", "translate(" + trans_x + "," + trans_y + ")");
  // }
  self.svg = $el.append("svg")
    .attr("class", chartType + "-svg")
    .attr("width", showUnit ? width : svgWidth)
    .attr("height", showUnit ? height : svgHeight);
  const gWrapper = self.svg.append("g")
    .attr("transform", "translate(" + trans_x + "," + trans_y + ")");

  //divide is a total value of all region
  var divide = 0;
  const values = [];
  Object.keys(sortedData).forEach(function(key) {
    divide += sortedData[key];
    values.push(sortedData[key]);
  });
  self.min_value = Math.min(...values);
  self.max_value = Math.max(...values);

  // put data to arc
  const gArc = gWrapper.selectAll('.arc')
    .data(pieData)
    .enter().append('g')
      .attr('class', 'arc');

  if (showLegendLine) {
    var all_left_points={};
    var all_right_points={};
    var text_points={};
    var min_percentage=0.9;
    // function rotate(cx, cy, x, y, angle) {
    //   var radians = (Math.PI / 180) * angle,
    //       cos = Math.cos(radians),
    //       sin = Math.sin(radians),
    //       nx = (cos * (x - cx)) + (sin * (y - cy)) + cx,
    //       ny = (cos * (y - cy)) - (sin * (x - cx)) + cy;
    //   return [nx, ny];
    // }
  }

  function midAngle(d) {
    return d.startAngle + (d.endAngle - d.startAngle) / 2;
  }

  // Attach current value to g so that we can use it for animation
  const pathArcs = gArc.append('path')
    .attr('path-name', function(d) {
      return d.data[0]; // d.data.key;
    })
    .attr('d', arc)
    .style('fill', function(d) {
      return color(d.data[0]); // color(d.data.key);
    })
    .style("cursor", "pointer")
    .each(function (d) {
      this._current = d;
      if(showLegendLine){
        var interpolate = d3.interpolate(this._current, d);
        this._current = interpolate(0);
        var d2 = interpolate(1);
        var pos = outerArc.centroid(d2);
        text_points[d.data[0]] = pos; // text_points[d.data.key]=pos;
        // if((d.data.value * 100) / divide>min_percentage) (midAngle(d2) < Math.PI)?(all_right_points[d.data.key]=pos):(all_left_points[d.data.key]=pos);
        if (((d.data[1] * 100) / divide) > min_percentage) {
          if (midAngle(d2) < Math.PI) {
            all_right_points[d.data[0]] = pos;
          } else {
            all_left_points[d.data[0]] = pos;
          }
        }
      }
    });
  pathArcs
    .on('mouseover', function(e) {
      if (self.isLock) return;
      // when mouseover grayout unselected pie slices
      const allArcSelections = self.svg.selectAll('.arc');
      const thisSelection = d3.select(this);
      const parentSelection = d3.select(this.parentNode);
      const datum = thisSelection.datum();

      allArcSelections.selectAll('path') // $(".arc path")
        .style('opacity', .35); // .attr("class", "path-grayout");
      allArcSelections.selectAll('text') // $(".arc text")
        .style('display', 'none'); // .attr("style", "display: none");
      allArcSelections.selectAll('line') // $(".arc line")
        .style('display', 'none'); // .attr("style", "display: none");
      allArcSelections.selectAll('.slice-value')
        .style('display', 'none');
      // $(".arc [data-name='"+e.data.key+"'] tspan").attr("style", "font-size: 11px;font-family: arial;white-space:pre;");

      parentSelection.select('text')
        .style('display', 'block');
      parentSelection.select('line')
        .style('display', 'block');
      thisSelection // $(".arc [path-name='"+e.data.key+"']")
        .style('opacity', 1); // .attr("class", "");
      // $(".arc [data-name='"+e.data.key+"']").attr("style", "display: block");

      const textTooltipSelection = parentSelection.select('.text-tooltip');
      var ellipsis = textTooltipSelection.attr('data-ellipsis'); // $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.text-tooltip").attr('data-ellipsis');

      if (ellipsis == 'true') {
        textTooltipSelection.style('display', 'none'); // $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.text-tooltip").attr("style", "display: none");
      }
      // else{
      //   $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.text-tooltip").attr("style", "display: block");
      // }
      // var slice_value_count = $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.slice-value").length - 1;
      let middle_text = parseInt(textTooltipSelection.node().getComputedTextLength() / 2) + 5; // parseInt($(".arc text[data-name='"+e.data.key+"'] tspan.text-tooltip")[0].getComputedTextLength()/2)+5;
      const sliceValueSelection = parentSelection.select('.slice-value');
      sliceValueSelection // $(".arc text[data-name='"+e.data.key+"'] tspan.slice-value")
        .attr('x', text_points[datum.data[0]][0] < 0 ? `-${middle_text}px` : `${middle_text}px`)
        .style('display', 'block') // .attr("style", "display: block;font-size: 11px;font-family: arial;white-space:pre;");
        .style('font-size', '11px')
        .style('font-family', 'arial')
        .style('white-space', 'pre');
      // $(".arc text[data-name='"+e.data.key+"'] tspan.slice-value").attr("x", (text_points[e.data.key][0]<0)?"-"+middle_text+"px":middle_text+"px");//$(".arc text[data-name='"+e.data.key+"'] tspan.text-tooltip").width()/2)
      if (ellipsis == 'true') {
        middle_text += 20;
        parentSelection.select('.slice-value:nth-last-child(1)') // $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.slice-value:nth-last-child(1)")
          .attr('x', text_points[datum.data[0]][0] < 0 ? `-${middle_text}px` : `${middle_text}px`);
      }
      if (self.onHover) self.onHover(getEventDatum(datum));
    })
    .on('click', function() {
      if (self.isLock) {
        self.isLock = false;
        return;
      }
      self.isLock = true;
      const thisSelection = d3.select(this);
      // const mouseoverEvent = new Event('mouseover');
      // thisSelection.get().dispatchEvent(moseoverEvent);
      if (self.onClick) self.onClick(getEventDatum(thisSelection.datum()));
    })
    .on('mouseout', function (e) {
      if (self.isLock) return;
      const allArcSelections = self.svg.selectAll('.arc');
      const thisSelection = d3.select(this);
      const parentSelection = d3.select(this.parentNode);
      allArcSelections.selectAll('path') // $(".arc path")
        .style('opacity', 1); // .attr("class", "");
      //$(".arc [path-name='"+e.data.key+"']").attr("class", "");

      allArcSelections.selectAll('text') // $(".arc text")
        .style('display', 'block'); // .attr("style", "display: block");
      allArcSelections.selectAll('line') // $(".arc line")
        .style('display', 'block'); // .attr("style", "display: block");
      allArcSelections.selectAll('[data-show="sometime"]') // $(".arc [show='sometime']")
        .style('display', 'none'); // .attr("style", "display: none");
      parentSelection.select('.slice-value') // $(".arc text[data-name='"+e.data.key+"'] tspan.slice-value")
        .style('display', 'none'); // .attr("style", "display: none");
  
      // const textTooltipSelection = parentSelection.select('.text-tooltip');
      // var ellipsis = textTooltipSelection.attr('data-ellipsis'); // $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.text-tooltip").attr('data-ellipsis');
      // if(ellipsis == 'true') {
      //   $(this).parent().find("text[data-name='"+e.data.key+"'] tspan.text-tooltip")
      //     .attr("style", "display: block;font-size: 11px;font-family: arial;white-space:pre;");
      // }
    });

  if (showLegendLine) {
    function check_overlap(points ,is_left) {
      //points.sort();console.log(points);
      var el_height=15;
      let keys;
      // console.log(Object.keys(points));
      if(is_left) keys = Object.keys(points).reverse();
      else keys = Object.keys(points);
      var last=null;
      //points.forEach(function(val,idx)
      for(var i=0;i<keys.length;i++) {
        const idx = keys[i];
        const val=points[idx];
        const current = val;
        if (last!=null) {
          if (current[1]-last[1]<el_height) {
            //current[0]=(current[1]>0)?last[0]-el_height:last[0]+el_height;
            const new_y = last[1]+el_height;
            var new_x=Math.cos(Math.asin(new_y/(outerRadius * radisuMultiply)))*(outerRadius * radisuMultiply);
            if(isNaN(new_x)) {
              last[1]=current[1]-el_height;
              last[0]=Math.cos(Math.asin(last[1]/(outerRadius * radisuMultiply)))*(outerRadius * radisuMultiply);
              if (is_left) last[0]=-last[0];
            } else {
              current[1]=new_y;
              current[0]=new_x;
              if (is_left) current[0]=-current[0];
            }
            //current=rotate(0, 0, current[0], current[1], 20)
          }
        }
        last=current;
      };
      //if(is_left) points.reverse();
    }
  
    check_overlap(all_left_points,true);
    check_overlap(all_right_points,false);
    var outerArc1 = d3.arc() // d3.svg.arc()
      .innerRadius(outerRadius)
      .outerRadius(outerRadius);

    // render leader line
    // var x2Points;
    const line = gArc.append("line")
      .attr("data-name", function(d) {
        return d.data[0]; // d.data.key;
      })
      .attr("x1", function(d) {
        return outerArc1.centroid(d)[0];
      })
      .attr("x2", function(d) {
        return text_points[d.data[0]][0]; // text_points[d.data.key][0];
        //return (text_points[d.data.key][0] - outerArc1.centroid(d)[0]) >= 20? (x2Points[d.data.key] = outerArc1.centroid(d)[0] + 20):text_points[d.data.key][0]; })
        // (text_points[d.data.key][0] - 50)
        // > 100)? text_points[d.data.key][0] - 20 : text_points[d.data.key][0]})
      })
      .attr("y1", function(d) {
        return outerArc1.centroid(d)[1];
      })//(chartType === donutText)?(lineY2*3):(lineY2*1.85))//function (d) {return text_points[d.data.key][0]})
      .attr("y2", function(d) {
        return text_points[d.data[0]][1]; // text_points[d.data.key][1];
      })//lineY2)//function (d) {return text_points[d.data.key][1]})
      .attr("stroke", "black")//function (d) {return color(d.data.key)})
      /*.attr("transform", function (d) {
         return "translate(" + ((arc.centroid(d)[0])) + "," + ((arc.centroid(d)[1])) + ") rotate(" + (d.startAngle + d.endAngle) / 2 * (180 / Math.PI) + ")";
      });*/

    // render text label
    gArc.append("text")
      .attr("data-name", function(d) {
        return d.data[0]; // d.data.key
      })
      .attr("transform", function(d) {
        // var dist = radius + 35;
        // var winkel = (d.startAngle + d.endAngle) / 2;
        // var x = dist * Math.sin(winkel);
        // var y = -dist * Math.cos(winkel);
        // var y = x2Points[d.data.key];
        // return "translate(" + text_points[d.data.key] + ")";
        return `translate(${text_points[d.data[0]]})`;
      })
      .attr("dy", "0em")
      .attr("fill", "black")
      .each(function(d) {
        var geo_name = d.data[0]; // d.data.key;
        var geo_type = '';
        var geo_alias = '';

        if (showPercentage) {
          var percentage = (d.data[1] * 100) / divide; // (d.data.value * 100) / divide;
          var percent_tag = " " + FormatHelper.formatEscapNumber(0, 100, percentage) + "%";
          var value = FormatHelper.formatEscapNumber(self.min_value, self.max_value, d.value);
          // var len = d.data.key.length;
          var tip_name = geo_type !== undefined ? geo_name : geo_alias;
          var tooltip_str = tip_name+" "+percent_tag;
          // tooltip_str.length <
          var reduced_limit = (""+percent_tag).length + 3;
          var limit, tooltip_string;

          //   var isCountry = 1;
          //   var isRu = 0;
          if(svgWidth <= 200) {
             if(isCountry)limit = 8
             else{
            //     if(isRu)
            //         limit=30
            //     else
                    limit=11
             }
             tooltip_string = (tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag;
             //tooltip_string = (geo_name+" "+percent_tag).substring(0, limit) + "...";
           } else if(svgWidth <= 316) {
            // if(isRu && !isCountry)
            //     limit = 30;
            // else
                limit = 11;
            tooltip_string = (tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag;
            //tooltip_string = (geo_name+" "+percent_tag).substring(0, limit) + "...";
          } else if(svgWidth <= 400) {
            if(text_points[d.data.key][1] > -50 && text_points[d.data.key][1] < 50) { //28
              // if(isRu && !isCountry)
              //   limit = 30;
              // else
                limit = 12;      //y-axis //-67,35
            }
            else if(text_points[d.data.key][1] > -67 && text_points[d.data.key][1] < 67) { //35
              // if(isRu && !isCountry)
              //   limit = 30;
              // else
                limit = 17;      //y-axis //-67,35
            }
            else if(text_points[d.data.key][1] > -87 && text_points[d.data.key][1] < 87){  //75
              // if(isRu && !isCountry)
              //   limit = 30;
              // else
                limit = 22;
            } else {
                // if(isRu && !isCountry)
                //     limit = 30;
                // else
                  limit = 25;
            }
            //tooltip_string = (geo_name+" ").substring(0, limit - reduced_limit)+"... "+percent_tag;
            tooltip_string = ((tip_name+" "+percent_tag).length  > limit) ?  ((tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag) : (tip_name+" "+percent_tag);
          } else if(svgWidth <= 500) {
            if(text_points[d.data.key][1] > -50 && text_points[d.data.key][1] < 50) {
              limit = 30      //y-axis //-67,35
            } else limit = 35;
            //tooltip_string = (geo_name+" ").substring(0, limit - reduced_limit)+"... "+percent_tag;
            tooltip_string = ((tip_name+" "+percent_tag).length  > limit) ?  ((tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag) : (tip_name+" "+percent_tag);
          } else if(svgWidth <= 600){
            if(text_points[d.data.key][1] > -110 && text_points[d.data.key][1] < 110) {
              limit = 28      //y-axis //-67,35
            } else limit = 50;
            tooltip_string = ((tip_name+" "+percent_tag).length  > limit) ?  ((tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag) : (tip_name+" "+percent_tag);
          } else if(svgWidth <= 700){
            limit = 50;
            tooltip_string = ((tip_name+" "+percent_tag).length  > limit) ?  ((tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag) : (tip_name+" "+percent_tag);
          } else{
            limit = 70;
            tooltip_string = ((tip_name+" "+percent_tag).length  > limit) ?  ((tip_name).substring(0, limit - reduced_limit)+"... "+percent_tag) : (tip_name+" "+percent_tag);
          }
          //str_arr= wordwrap(geo_name+" "+percent_tag, limit, '<br/>');

          d3.select(this).append("tspan")
            .attr("full-data", function (d) {
              return tip_name+" "+percent_tag;
            })
            .attr("data-ellipsis", function(){
              return (tooltip_string.indexOf('...') >= 0);
            })
            .attr("x", function(d) {
              // (text_points[d.data.key][0]<0)?"-5px":"5px"
              return text_points[d.data[0]][0] < 0 ? '-5px' : '5px';
            })
            .attr("text-anchor", function(d) {
              // (text_points[d.data.key][0]<0)?"end":"start"
              return text_points[d.data[0]][0] < 0 ? 'end' : 'start';
            })
            .attr("y", '4px')
            .style("font-size", "11px")
            .style("font-family", "arial")
            .style("white-space", "pre")
            .attr("class", "text-tooltip")
            .text(tooltip_string); //.text(geo_name+" "+percent_tag)

          //limit += 3;
          if(tooltip_string.indexOf('...') >= 0){ //ellipsis - true
            //str_arr= wordwrap(tooltip_str, limit, '<br/>');
            str_arr = wrap_word_with_char_count(tooltip_str, limit);
            str_arr.push(value);
            total_middle = (text_points[d.data.key][0]<0)? '-40px': '40px';
            for(var i = 0; i < str_arr.length; i++){
              d3.select(this).append("tspan")
              .attr("class","slice-value")
              .attr("style", "display: none")
              .text(str_arr[i])
              .attr("y", ((i) * 14)+'px')
              //.attr("text-anchor", "middle");
              .attr("text-anchor", (i == str_arr.length - 1)? 'middle':((text_points[d.data.key][0]<0)?"end":"start"))
              .attr("x", (i == str_arr.length - 1)? total_middle:((text_points[d.data.key][0]<0)? '-20px':'20px'));
            }
          }else{
            d3.select(this).append("tspan")
              .attr("class","slice-value")
              .attr("style", "display: none")
              .attr("x", '0px')
              .attr("y",'15px')
              .attr("text-anchor", "middle")
              .text(value);
          }

          /*d3.select(this).append("tspan")
            .text(percent_tag)
            .attr("x", function (d) { return (len/2-value.length/2);})
            .attr("y", '2.2em')
            .attr("text-anchor", "middle");*/
          if (percentage < min_percentage) {
            // $(".arc [data-name='" + d.data.key + "']").attr("show", "sometime");
            d3.select(this.parentNode).selectAll(`[data-name="${geo_name}"]`)
              .attr('data-show', 'sometime');
          }
        }
      });

		if (showTitle) {
      g.select("text").text(function (d) {
        return d.data.key;
      });
    }

    // For less than min_percentage
    d3.selectAll(".arc [data-show='sometime']")
      .style('display', 'none');
  } else { // not show legend line
  	// render text label
		g.append("text")
      .attr("data-name", function (d) {
        return d.data.key
      })
      .attr("transform", function (d) {
        var x = 0;
        var y = -(radius + (radius / 10));
        return "translate(" + x + "," + y + ")";
      })
      .attr("dy", ".35em")
      .style("text-anchor", "middle")
      .style("font-size", '1.5em')
      .attr("class", "text-tooltip")
      .each(function (d) {
        if (showPercentage) {
          var percentage = (d.data[1] * 100) / divide; // (d.data.value * 100) / divide;
          var percent_tag = "(" + FormatHelper.formatEscapNumber(0, 100, percentage) + "%)";
          var value = FormatHelper.formatEscapNumber(self.min_value, self.max_value, d.value);

          d3.select(this).append("tspan")
            .text(d.data.key)
            .attr("class", "text-tooltip")
            .attr("x", 0)
            .attr("y", 0)
            .attr("text-anchor", "middle");
          d3.select(this).append("tspan")
            .text(value + ' ' + percent_tag)
            .attr("class", "text-tooltip")
            .attr("x", 0)
            .attr("y", 10 + (radius / 10))
            .attr("text-anchor", "middle");
        }
      });

    if (showTitle) {
      g.select("text").text(function (d) {
          return d.data.key;
      });
    }

    // hide for all slices
    d3.selectAll(".arc text").each(function () {
      $(this).attr("style", "display: none");
    });

    d3.selectAll(".arc line").each(function () {
      $(this).attr("style", "display: none");
    });

     // TODO: Should accept this alternative name as parameter !!
    $('text[data-name="ESCAP"] > tspan').first().html('Asia and the Pacific');

    if(enableMouseInteraction){
      $("." + chartType + "-svg .arc path").off('mouseover').on('mouseover', function(event){
        var path_data_name = $(event.currentTarget).attr("path-name"),
            height = $("svg." + chartType + "-svg").attr("height");
        $(".arc text,line").attr("style", "display: none");
        $(".arc [data-name='" + path_data_name + "']").attr("style", "display: block");
        $(".arc [data-name='" + path_data_name + "']").attr("style",
            "text-anchor: middle; font-size: " + 1.3 + "em");
        $(".arc [data-name='" + path_data_name + "'] tspan").attr("style", "font-size: 11px;font-family: arial;white-space:pre;");
        $("." + chartType + "-svg .arc path").attr("class", "path-grayout");
        $(".arc [path-name='" + path_data_name + "']").attr("class", "");
      });

      $("." + chartType + "-svg .arc path").off('mouseout').on('mouseout', function(event){
        var path_data_name = $(event.currentTarget).attr("path-name"),
            height = $("svg." + chartType + "-svg").attr("height");
        $(".arc [data-name='" + path_data_name + "']").attr("style", "display: none");

        $("."+chartType+"-svg .arc path").attr("class", "");
        $(".arc text").attr("style", "display: none");
      });
    }
  }
  // END

  // show total value
  var total_value_font;
  if(innerRadius <= 22) total_value_font = 0.7
  else if(innerRadius <= 32) total_value_font = 1;
  else total_value_font = 1.4;

  if(showTotal){
    var total = 0;
    Object.keys(sortedData).forEach(function(key) {
      total += sortedData[key];
    });
    const displayTotal = numberFormat(Math.round(total));
    gWrapper.append("text")
      .text(displayTotal)
      .attr("x", 0)
      .attr("y", totalTextY)
      .attr("class", "text-tooltip")
      .style("text-anchor", "middle")
      .attr("fill", "darkgray")
      .attr("font-weight", "bold")
      .style("font-size", total_value_font+"em"); //1.85em
	}

  // show unit text
  //totalUnitTextFontSize = 0.5;
  if (showUnit) {
    //str_arr= wordwrap(self.unitName, 20, '<br/>');
    const str_arr = wrap_word_with_char_count(self.unitName, 20);

    if(innerRadius <= 32) totalUnitTextFontSize = 0.5;
    else totalUnitTextFontSize =  0.7;
    for(var i = 0; i < str_arr.length; i++){
      gWrapper.append("text")
        .text(str_arr[i])
        .attr("x", 0)
        .attr("y", totalUnitTextY + (i * 8))
        .attr("class", "text-tooltip")
        .style("text-anchor", "middle")
        .attr("fill", "darkgray")
        .attr("font-weight", "bold")
        .style("font-size", totalUnitTextFontSize +"em");
    }

    // svg.append("text")
    //   .text(self.unitName)
    //   .attr("x", 0)
    //   .attr("y", totalUnitTextY)
    //   .attr("class", "text-tooltip")
    //   .style("text-anchor", "middle")
    //   .attr("fill", "darkgray")
    //   .attr("font-weight", "bold")
    //   .style("font-size", totalUnitTextFontSize +"vw");
  }
}

PieDonut.prototype.redraw = function() { }
